<template>
    <div>
        <div class="modal fade" id="mdCadastroRapidoCliente" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Cadastro (rápido) de clientes</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-9 col-md-4 col-lg-4">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilialcadrapido" disabled="true" v-model="idfilial" data-placeholder="Selecionar filial" data-allow-clear="true" style="width:100%; font-weight: bold;"></select>
                            </div>   
                                  
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcnpjcpf">*CPF</label>
                                <input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcnpjcpf" 
                                    v-mask="'###.###.###-##'">
                            </div>  
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edcelular">*Celular:</label>
                                <input type="text" v-model="vcelular" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edcelular" 
                                    v-mask="['(##) ####-####', '(##) #####-####']">
                            </div>  
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="nome">*Nome:</label>
                                <input type="text" v-model="vnome" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="nome" 
                                    style="text-transform: uppercase;">
                            </div>  
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="eddtnascfund">Dt. Nascimento:</label>
                                <date-picker id="eddtnascfund" v-model="dtnascmento" :config="options" 
                                    class="form-control form-control-sm" ></date-picker>
                            </div>          
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <div class="container" style="padding-left: 0px; padding-right: 0px;">
                            <div class="row">
                                <div class="col-sm-2 col-md-3 col-lg-3" >
                                   
                                </div>                                
                                <div class="col-sm-2 col-md-3 col-lg-3">
                                   
                                </div>                                
                                <div class="col-sm-12 col-md-4 col-lg-4">
                                    <a href="#" role="button" class="btn btn-success btn-sm" data-toggle="modal" id="btcadastrarrapido" @click.prevent="mtdcadastrar()" name="btcadastrar" style="width:100%; margin-top: 20px;"><i class="fa fa-check"></i> Cadastrar</a>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100%; margin-top: 20px;"><i class="fa fa-close"></i> Cancelar</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
    </div>

</template>
<script>
	
    import util from '../utilitarios/util.js'
    export default{
        name : "cmpcadastrorapidocliente",
        props: [
            'idfilial',
            'descfil'
        ],

        data : function () {
			return {
                vcnpjcpf      : '',
                vcelular      : '',
                vnome         : '',
                dtnascmento   : util.DataAtual(true),
                vdtcadastro   : util.DataAtual(true),
                options: {
                    format              : 'DD/MM/YYYY',
                    useCurrent          : false,
                    locale              : 'pt-BR'
                },
            }
        },
        methods:{
            resetardados(){
                this.vcnpjcpf      = '';
                this.vcelular      = '';
                this.vnome         = '';
                this.dtnascmento   = util.DataAtual(true);
                this.vdtcadastro   = util.DataAtual(true);
            },
            mtdcadastrar(){
                let vself  = this;
               
                if(!this.idfilial){
                    this.$toastr.w('Informe a filial', 'Atenção!');
                    return
                }
                if(!this.vcelular){
                    this.$toastr.w('Informe o telefone do cliente', 'Atenção!');
                    return
                }
                if ((vself.vcnpjcpf.length < 11) || ($.trim(vself.vcnpjcpf.replace(/[^\d]+/g,'')) === '')){
                        vself.$toastr.i("CPF deve ser informado!", "Atenção!");
                        $("#edcnpjcpf").focus();
                        return;
                }

                if (!util.validarCPF(vself.vcnpjcpf)){
                    vself.$toastr.i("CPF informado não é válido!", "Atenção!");
                    $("#edcnpjcpf").focus();
                    return;
                }

                if(!this.vnome){
                    this.$toastr.w('Informe o nome do cliente', 'Atenção!');
                    return
                }
                if(!this.dtnascmento){
                    this.$toastr.w('Informe a data de nascimento', 'Atenção!');
                    return
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma cadastrar esse cliente?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: 'Sim',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                let loader = vself.$loading.show();
                                let registrocrud = {
                                    'idfilial'        : vself.idfilial,
                                    'celular'         : vself.vcelular.replace(/[^0-9]/g,''),
                                    'cpfcnpj'         : vself.vcnpjcpf.replace(/[^0-9]/g,''),
                                    'nome'            : vself.vnome,
                                    'dtnascfund'      : vself.dtnascmento,
                                    'dtcadastro'      : vself.vdtcadastro,
                                };
                                let parametros      = [
                                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                                    {parametro: 'op',           valor : 'cadastrarrapidopdv'},
                                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},                                   
                                ];
                                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                                retorno.then(function (response) {
                                    loader.hide();
                                    if ($.isNumeric(response.data)){
                                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                                        vself.resetardados();
                                        let payloadx = {
                                            idcliente    : response.data			
                                        };
                                        vself.$store.commit('RETORNO_CADASTRO_RAPIDO_CLI',payloadx);  
                                        $('#mdCadastroRapidoCliente').modal('hide');

                                    }else{
                                        let tpret = response.data.substring(0,1);
                                        switch (tpret) {
                                            case 'I':
                                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                                break;
                                            case 'E': default:
                                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                                break;
                                        }
                                    }
                                }).catch(function (response) {
                                    loader.hide();
                                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                                });
                            }
                        },
                        nao: {
                            text: 'Não',
                            keys: ['n', 'N'],
                            action: function () {
                                
                            }
                        }
                    }
                });




            }
        },
        watch:{
            idfilial(val){
                if(val){
                    $("#cbfilialcadrapido").val(null).trigger('change');


                    var deffil  = new Option(this.descfil, val, true, true);
                    $('#cbfilialcadrapido').append(deffil).trigger('change');   
                }
            }

        },
        mounted() {
            let vself         = this;
		    let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
            let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';       
            $("#cbfilialcadrapido").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.idfilial = $("#cbfilialcadrapido").val();
                });

        }

        

    }
</script>
<style>
</style>